"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBonusUpdateDto = instanceOfBonusUpdateDto;
exports.BonusUpdateDtoFromJSON = BonusUpdateDtoFromJSON;
exports.BonusUpdateDtoFromJSONTyped = BonusUpdateDtoFromJSONTyped;
exports.BonusUpdateDtoToJSON = BonusUpdateDtoToJSON;
exports.BonusUpdateDtoToJSONTyped = BonusUpdateDtoToJSONTyped;
/**
 * Check if a given object implements the BonusUpdateDto interface.
 */
function instanceOfBonusUpdateDto(value) {
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    return true;
}
function BonusUpdateDtoFromJSON(json) {
    return BonusUpdateDtoFromJSONTyped(json, false);
}
function BonusUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'amount': json['amount'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}
function BonusUpdateDtoToJSON(json) {
    return BonusUpdateDtoToJSONTyped(json, false);
}
function BonusUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'amount': value['amount'],
        'description': value['description'],
    };
}
//# sourceMappingURL=BonusUpdateDto.js.map